import { render, staticRenderFns } from "./DebitCompanyWallet.vue?vue&type=template&id=72dca9e6&"
import script from "./DebitCompanyWallet.vue?vue&type=script&lang=js&"
export * from "./DebitCompanyWallet.vue?vue&type=script&lang=js&"
import style0 from "./DebitCompanyWallet.vue?vue&type=style&index=0&id=72dca9e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports